import Vue from 'vue';
import moment from 'moment';

export default {
  name: 'CustomReading',
  props: ['dataObj'],
  data: function () {
    return {
      appData: {},
      disabledDates: date => {
        return this.appData ? this.appData.readonly : false;
      },
    }
  },
  computed: {
    curReadingValue: function () {
      return this.appData.curReading;
    },
    prevReadingValue: function () {
      return this.appData.prevReading;
    },
    //calculatedConsumption: function () {
    //  var iConsumption = this.appData.curReading - this.appData.prevReading;
    //  return this.formatDateUI(moment(this.appData.readingDate));
    //},
  },
  watch: {
    curReadingValue: function (value) {
      if (this.appData.curReading === 0 && this.appData.prevReading === 0)
        this.appData.consumption = 0;
      else
        this.appData.consumption = (+this.appData.curReading > +this.appData.prevReading) ? +this.appData.curReading - +this.appData.prevReading : +Math.pow(10, this.appData.prevReading.length) - +this.appData.prevReading + +this.appData.curReading;
    },
    prevReadingValue: function (value) {
      if (this.appData.curReading === 0 && this.appData.prevReading === 0)
        this.appData.consumption = 0;
      else
        this.appData.consumption = (+this.appData.curReading > +this.appData.prevReading) ? +this.appData.curReading - +this.appData.prevReading : +Math.pow(10, this.appData.prevReading.length) - +this.appData.prevReading + +this.appData.curReading;
    }
  },
  created() {
    this.$root.$on('custom_meter_reading_updated', this.init);
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appData = this.$store.state.csAppsOfflineMode ? this.dataObj.data : this.dataObj;
      });
    },
  },
}
